export default __webpack_public_path__ + "static/media/create_poll_symbol.ed181e95.png";